import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SkillsService } from 'src/app/services/skills.service';
import { SkillsModalComponent } from './skills-modal/skills-modal.component';
import { SearchFilterComponent } from '../../shared/search-filter/search-filter.component';
import { PaginationComponent } from '../../shared/pagination/pagination.component';

@Component({
  selector: 'app-skills',
  imports: [CommonModule, SearchFilterComponent, PaginationComponent],
  templateUrl: './skills.component.html',
  styleUrls: ['./skills.component.css']
})
export class SkillsComponent implements OnInit {
  
  constructor(
      private dialog: MatDialog,
      private SkillsService: SkillsService,
      private changeDetectorRef: ChangeDetectorRef
  ) {} 

  
  SkillsList: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];
  pageSize: number = 10;

  ngOnInit(): void {
      this.getSkills();
  }

  getSkills(){
    this.SkillsService.getSkills().subscribe({
      next: (res: any) => {
        this.SkillsList = res;
        this.filteredData = res;
        this.changeDetectorRef.detectChanges();
      },
      error: (err: any) => {
        console.error('Error al cargar habilidades:', err);
        this.filteredData = [];
      }
    });
  };

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
  }

  openModal(item: any, mode: any, title: any) {
    const dialogRef = this.dialog.open(SkillsModalComponent, {
      data: { item, mode, title },
      maxWidth: '100%',
      width: '40%',
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
       
        if (!res) return
        if (res) {
          this.getSkills();
        }
      }
    });
  }

}
